// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"cb52e72a","90":"9e1a9555","184":"73d3c308","344":"37f3c294","389":"06430ee0","594":"d99a524c","595":"c02338cb","602":"8ebeb517","629":"afe7aa51","861":"fe97eca2","909":"e9621f39","943":"391d7f7d"}[chunkId] + ".chunk.js";
};